import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Switch } from "react-router";
import { BrowserRouter } from "react-router-dom";

import { ComponentAppRoute, ComponentToast } from "@components";

import { authApi, merchantApi } from "@api";
import { routes } from "@configs";
import { IMerchant, IRoute } from "@interfaces";
import { PageHistoryPublic } from "@pages";
import {
    getInfo,
    logout,
    removeConfigClient,
    resetMerchant,
    selectAuth,
    selectConfigClient,
    selectMerchant,
    selectPage,
    setMerchant,
    setMerchantSetting,
} from "@redux";
import Drawer from "@Rocket-Innovation/components/shared/Drawer";
import LoadOverlay from "@Rocket-Innovation/components/shared/LoadOverlay";
import SubDrawer from "@Rocket-Innovation/components/shared/SubDrawer";
import { useFullScreen } from "src/Helpers/useFullscreen";
import useCache from "src/Store/useCache";

export const ModuleMain = () => {
    //page hooks
    const dispatch = useDispatch();

    //redux state
    const { auth, userInfo } = useSelector(selectAuth);
    const { showPopupHistory } = useSelector(selectPage);
    const { _id } = useSelector(selectMerchant);
    const configClient = useSelector(selectConfigClient);
    //page variable
    const token = auth?.accessToken;
    const link = new URL(location.href);
    const merchantID = link.searchParams.get("merchant_id");
    const historyId = link.searchParams.get("history_id");
    const fullHeight = useFullScreen();
    const isLoading = useCache((state) => state.isLoading);
    const prefix = window.location.hostname.split(".")[0];

    const getUserInfo = () => {
        if (token) {
            dispatch(getInfo());
        }
    };

    const getMerchant = async () => {
        if (_id) {
            try {
                const merchantConfig = await merchantApi.getMerchantNew();
                console.log("getMerchantNew => 2");
                const merchant = merchantConfig.data.data as IMerchant;
                if (merchant) {
                    dispatch(setMerchant(merchant));
                    dispatch(setMerchantSetting());
                    // dispatch(setMainColor(merchant.themes?.themeColor));
                    if (!merchant.enableAccess) {
                        const index = configClient.findIndex(
                            (item) => item.merchantId === merchant._id
                        );
                        if (index >= 0) {
                            dispatch(removeConfigClient(index));
                        }
                        dispatch(resetMerchant());
                        dispatch(logout());
                    }
                }
            } catch {
                dispatch(resetMerchant());
            }
        }
    };

    useEffect(() => {
        getUserInfo();
    }, [token]);

    useEffect(() => {
        if ((prefix === "futurepark" || prefix === "hamtest") && userInfo) syncBalance();
    }, [userInfo]);

    const syncBalance = async () => {
        await authApi.syncBalance(userInfo?._id || "");
    };

    // useEffect(() => {
    //     getMerchant();
    // }, []);

    return (
        <BrowserRouter>
            <Switch>
                {routes.map((e: IRoute, key) => (
                    <ComponentAppRoute key={key} {...e} />
                ))}
            </Switch>
            <ComponentToast />
            {showPopupHistory && (
                <PageHistoryPublic merchantId={merchantID} historyId={historyId} />
            )}
            {/* <NewDrawer /> */}
            <Drawer />
            <span style={{ color: "black" }}>
                <SubDrawer />
            </span>
            <LoadOverlay text="Please wait..." blur={20}>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: fullHeight,
                        pointerEvents: isLoading ? "all" : "none",
                    }}
                />
            </LoadOverlay>
        </BrowserRouter>
    );
};
